import { CMultiSelect } from '@coreui/react-pro';
import { useEffect, useState } from 'react'
import * as _ from 'lodash';

interface IMultiSelectDropdown {
  defaultOptions: { value: string; text: string; }[];
  values: any[];
  zIndex: number;
  isDisabled?: boolean;
  onChangeField?: Function;
  field?: string;
  state?: any;
  onChange?: any;
  placeholder?: string;
  selectAll?: boolean;
}

interface DropdownState {
  displayOptions: any[];
  previousOptions: any[];
}

const MultiSelectDropdown = ({ defaultOptions, values = [], zIndex, isDisabled = false, onChangeField, field, state, onChange, placeholder, selectAll }: IMultiSelectDropdown) => {

  const [dropdownState, setDropdownState] = useState<DropdownState>({
    displayOptions: defaultOptions,
    previousOptions: []
  });

  const onChangeValue = (itemList: any[]) => {
    if (onChangeField) {
      onChangeField(itemList, field, state, onChange);
    }
    afterUserSelectOptions(itemList);
  }

  const afterUserSelectOptions = (itemList: any[]) => {
    let tempDisplayOptions = dropdownState.displayOptions;
    if (itemList.length > 0 && itemList.some(v => v.value == "ALL")) {
      tempDisplayOptions = dropdownState.displayOptions.map((o: any) => {
        if (o.value !== 'ALL') {
          o.disabled = true;
          o.selected = false;
        } else {
          o.disabled = false;
          o.selected = true;
        }
        return o;
      })
    } else if (itemList.length > 0) {
      tempDisplayOptions = dropdownState.displayOptions.map((o: any) => {
        if (itemList.some(v => v.value == o.value)) {
          o.selected = true;
        }
        o.disabled = false;
        return o;
      })
    } else if (itemList.length === 0) {
      tempDisplayOptions = dropdownState.displayOptions.map((o: any) => {
        o.disabled = false;
        o.selected = false;
        return o;
      })
    }
  
    setDropdownState({
      previousOptions: itemList,
      displayOptions: tempDisplayOptions,
    });
  }

  return (
    <div className={`${isDisabled ? "multi-select-disabled" : "multi-select"}`} style={isDisabled ? { pointerEvents: "none" } : {}}>
      <CMultiSelect
        placeholder={placeholder}
        style={{ zIndex: !!zIndex ? zIndex : 1039 }}
        onChange={(items) => {
          onChangeValue(items)
        }}
        options={dropdownState.displayOptions}
        selectionType="text"
        selectAll={selectAll}
        cleaner={false}
      />
    </div>
  )
}

export default MultiSelectDropdown;